const LogOutIcon = (props: any) => (
    <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Log out"
        {...props}
    >
        <g filter="url(#filter0_d_455_7801)">
            <path
                d="M2 9C2 4.58172 5.58172 1 10 1H30C34.4183 1 38 4.58172 38 9V29C38 33.4183 34.4183 37 30 37H10C5.58172 37 2 33.4183 2 29V9Z"
                fill="white"
            />
            <path
                d="M2.5 9C2.5 4.85786 5.85786 1.5 10 1.5H30C34.1421 1.5 37.5 4.85786 37.5 9V29C37.5 33.1421 34.1421 36.5 30 36.5H10C5.85786 36.5 2.5 33.1421 2.5 29V9Z"
                stroke="#ffffff"
            />
            <path
                d="M23.3333 23.1667L27.5 19M27.5 19L23.3333 14.8333M27.5 19H17.5M17.5 11.5H16.5C15.0999 11.5 14.3998 11.5 13.865 11.7725C13.3946 12.0122 13.0122 12.3946 12.7725 12.865C12.5 13.3998 12.5 14.0999 12.5 15.5V22.5C12.5 23.9001 12.5 24.6002 12.7725 25.135C13.0122 25.6054 13.3946 25.9878 13.865 26.2275C14.3998 26.5 15.0999 26.5 16.5 26.5H17.5"
                stroke="#344054"
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_455_7801"
                x={0}
                y={0}
                width={40}
                height={40}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={1} />
                <feGaussianBlur stdDeviation={1} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_455_7801"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_455_7801"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

export default LogOutIcon;
